import { createApp } from 'vue'
import App from './App.vue'
import VueWriter from "vue-writer";
import '@/assets/main.css'
import { MotionPlugin } from '@vueuse/motion'

createApp(App).use(VueWriter).use(MotionPlugin).mount('#app')
